import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { Navbar } from "./navbar";
import { Contact } from "./contact";
import "../styles/listeClimatisseurs.css";

export function CategorieClimatisseurs() {
    const { genreClimatisseur } = useParams();
    const listC = useSelector(s => s.listC) || [];
    const list = listC.filter(a => a.markClimatisseur == genreClimatisseur);

    return (
        <>
            <Navbar />
            <div className="climatiseurs-list-container">
                <div className="section-title-bar" style={{ backgroundColor: "#000033", padding: '20px 15px', marginTop: '-28px' }}>
                    Climatiseurs: {genreClimatisseur}
                </div>

                <div className="climatiseurs-grid" style={{ marginTop: '40px' }}>
                    {list.map(a => (
                        <div key={a.id} className="climatiseur-card">
                            <div className="card-image-wrapper">
                                <img src={a.image} alt={a.nomClimatisseur} />
                            </div>
                            <div className="card-info">
                                <h3 className="climatiseur-name">{a.nomClimatisseur}</h3>
                                <p className="climatiseur-price">{a.tailles[0].prix}</p>
                                <Link to={`/listeClimatisseurs/${a.id}`} className="btn-add-cart">
                                    Ajouter au panier
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>

                {list.length === 0 && (
                    <div style={{ textAlign: 'center', marginTop: '40px', color: '#666' }}>
                        <p>Aucun climatisseur trouvé pour la catégorie "{genreClimatisseur}"</p>
                    </div>
                )}
            </div>
            <Contact />
        </>
    );
}
